var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 120,
    viewBox: "0 0 180 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.644 58.3477C147.74 59.236 146.598 59.8706 148.248 60.505C149.568 61.013 153.028 62.155 154.593 62.663",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5899 53.1445C32.0012 54.0329 32.1281 54.6674 30.9859 55.8096C30.0722 56.7234 29.1669 57.4594 28.8285 57.7133",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.629 75.48C148.629 75.48 153.452 75.48 153.959 75.48C155.777 75.48 156.751 73.069 155.863 71.8C157.132 67.358 156.751 60.885 155.736 58.4741C148.122 52.1287 121.724 50.7327 115.76 50.7327C112.206 48.093 102.563 42.3 97.231 40.5799C93.297 39.3108 85.3015 38.5687 71.8491 38.6763C59.1582 38.7778 42.9561 46.164 36.4414 49.8443H26.7963C25.9926 51.325 24.5373 55.0477 25.1465 58.0935C22.4814 59.9971 22.7351 68.272 26.0349 70.911C29.5885 73.754 37.9643 73.83 37.9643 73.83M61.3156 75.353H124.39",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2618 81.7057C54.663 81.7057 59.0415 77.3272 59.0415 71.926C59.0415 66.5249 54.663 62.1464 49.2618 62.1464C43.8607 62.1464 39.4822 66.5249 39.4822 71.926C39.4822 77.3272 43.8607 81.7057 49.2618 81.7057Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.079 81.7057C142.48 81.7057 146.859 77.3272 146.859 71.926C146.859 66.5249 142.48 62.1464 137.079 62.1464C131.678 62.1464 127.299 66.5249 127.299 71.926C127.299 77.3272 131.678 81.7057 137.079 81.7057Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.111 53.2714L51.2906 50.8601C50.1488 49.591 49.3871 47.3066 49.3871 47.3066",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4144 57.332L90.887 57.5858",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7308 56.5703L62.2032 56.8241",
    stroke: "black",
    strokeOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.2b46431602331362e516c2dc3ba7d2d8.svg";
export { ForwardRef as ReactComponent };